import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    flexGrow: 1,
    minHeight: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function LoadingGraph({ className, ...props }) {
  const classes = useStyles();
  return (
    <div className={clsx(classes.wrapper, className)}>
      <CircularProgress />
    </div>
  );
}
